// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"561":"18ff873f","731":"bb816977"}[chunkId] + ".chunk.css";
};